import { jwtDecode } from "jwt-decode";
import { getLocalStorage } from "../../../utils/storageUtil";
import { JWT_TOKEN } from "../../../constant";

export const tabKeys = {
  staff_details: "staff_details",
  resignation_details: "resignation_details",
  terminated_staff_details: "terminated_staff_details",
  termination_details: "termination_details",
  transfer_trainings_others: "transfer_trainings_others",
  salary_scale: "salary_scale",
  staff_loan: "staff_loan",
  function_wise_allowance: "function_wise_allowance",
  oyvs: "oyvs",
};

export const tabLabel = {
  staff_details: "Staff Details",
  resignation_details: "Resignation Details",
  terminated_staff_details: "Terminated Staff's Details",
  termination_details: "Termination Details",
  transfer_trainings_others: "Transfer Trainings Others",
  // indicators_summary: "Indicators Summary",
  salary_scale: "Salary Scale",
  staff_loan: "Staff Loan",
  function_wise_allowance: "Function Wise Allowance",
  oyvs: "OYVS",
};

export const fiscalQuarterOption = [
    {
      label: "First Quarter",
      value: "first_quarter"
    },
    {
      label: "Second Quarter",
      value: "second_quarter"
    },
    {
      label: "Third Quarter",
      value: "third_quarter"
    },
    {
      label: "Fourth Quarter",
      value: "fourth_quarter"
    }
  ]

export const isAllowedEditOption = (role, memberId) => {
  try {
    const token = getLocalStorage(JWT_TOKEN);
    const decoded = jwtDecode(token);
    if (decoded?.role === "ADMIN" || role === "ALL") {
      return true;
    }
    if (decoded?.member_id === memberId) {
      return true
    }
    return false;
  } catch (error) {
    throw error
  }
}